$(function(){
    // MEGAMENU
    let megamenuTrigger = $('.megamenu-trigger'),
        megamenu = $('.megamenu');

    $(window).on('keydown', function(e){
        if (e.keyCode === 27) {
            closeMegamenu();
        }
    })

    megamenuTrigger.on({
        mouseenter: function(){
            $(this).openMegamenu();
        },
        mouseleave: function(e){
            $(this).closeMegamenu(e);
        },
        click: function(e){
            e.preventDefault();

            if ($(this).attr('aria-expanded') === 'false') {
                $(this).openMegamenu();
            } else {
                $(this).closeMegamenu(e);
            }
        }
    });

    megamenu.on({
        focusout: function(e){
            if (e.relatedTarget && $(e.relatedTarget).closest('.megamenu').length === 0) {
                closeMegamenu();
            }
        },
        mouseleave: function(){
            closeMegamenu();
        }
    });

    $.fn.openMegamenu = function() {
        let trigger = $(this),
            menu = $('#' + trigger.attr('aria-controls'));

        menu.stop().fadeIn(200);
        trigger.parent().parent().find('> li > .megamenu-trigger').attr('aria-expanded', 'false');

        trigger.attr('aria-expanded', 'true');
    }

    function closeMegamenu() {
        megamenu.stop().fadeOut(200);
        megamenuTrigger.attr('aria-expanded', 'false');
    }

    $.fn.closeMegamenu = function(e) {
        if (e.relatedTarget && $(e.relatedTarget).hasClass('megamenu')) {
            return;
        }

        let trigger = $(this),
            menu = $('#' + trigger.attr('aria-controls'));

        menu.stop().fadeOut(200);
        trigger.attr('aria-expanded', 'false');
    }

    // MEGAMENU MENUS
    $('.megamenu-menu-trigger').on('click', function(){
        let trigger = $(this);

        if (trigger.attr('aria-expanded') === 'false') {
            trigger.openMegamenuMenu();
        } else {
            trigger.closeMegamenuMenu();
        }
    })

    $.fn.openMegamenuMenu = function() {
        let trigger = $(this),
            menu = $('#' + trigger.attr('aria-controls'));

        trigger.parent().parent().find('> li > .megamenu-menu-trigger').each(function(){
            let thisTrigger = $(this),
                thisMenu = $('#' + thisTrigger.attr('aria-controls'));

            thisMenu.stop().fadeOut(200);
            thisTrigger.attr('aria-expanded', 'false');
        })

        menu.stop().fadeIn(200);
        trigger.closest('ul').css('min-height', menu.outerHeight() + 'px');
        trigger.attr('aria-expanded', 'true');
    }

    $.fn.closeMegamenuMenu = function() {
        let trigger = $(this),
            menu = $('#' + trigger.attr('aria-controls'));

        menu.stop().fadeOut(200);
        trigger.closest('ul').css('min-height', '1px');
        trigger.attr('aria-expanded', 'false');
    }
})